import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PipeModule} from '../../pipe/pipe.module';
import {DirectiveModule} from '../../directives/directives.module';
import {SharedModule} from '../obs.shared/shared.module';
import {BarrierefreiheitIconComponent} from './components/barrierefreiheitIcon/barrierefreiheitIcon.component';
import {BarrierefreiheitEinstellungenComponent} from './components/barrierefreiheitEinstellungen/barrierefreiheitEinstellungen.component';
import {BarrierefreiheitTextanpassungComponent} from './components/barrierefreiheitTextanpassung/barrierefreiheitTextanpassung.component';
import {
  BarrierefreiheitTastenbelegungAnsichtComponent
} from './components/barrierefreiheitTastenbelegungAnsicht/barrierefreiheitTastenbelegungAnsicht.component';
import {BarrierefreiheitTastenbelegungService} from './services/tastenbelegung.service';
import {BarrierefreiheitTextanpassungService} from './services/textanpassung.service';
import {MaterialModule} from '../../assets/material.module';
import {BarrierefreiheitService} from './services/barrierefreiheit.service';

@NgModule({
  declarations: [
    BarrierefreiheitIconComponent,
    BarrierefreiheitEinstellungenComponent,
    BarrierefreiheitTextanpassungComponent,
    BarrierefreiheitTastenbelegungAnsichtComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    FormsModule,
    PipeModule,
    DirectiveModule,
    ReactiveFormsModule,
    SharedModule,
    MaterialModule,
  ],
  exports: [
    BarrierefreiheitIconComponent,
    BarrierefreiheitEinstellungenComponent,
    BarrierefreiheitTextanpassungComponent,
    BarrierefreiheitTastenbelegungAnsichtComponent,
  ],
  providers: [
    BarrierefreiheitService,
    BarrierefreiheitTastenbelegungService,
    BarrierefreiheitTextanpassungService,
  ],
})
export class BarrierefreiheitModule {
}
